module.exports = __webpack_public_path__ + "img/chevron-right.3816154d.svg";